import { ReactNode } from "react";
import classNames from "classnames";

import styles from "./BillingCardContainer.module.scss";

interface IBillingCardContainerProps {
  children: ReactNode;
  className?: string;
}

export const BillingCardContainer: React.FC<IBillingCardContainerProps> = ({ children, className }) => {
  return <div className={classNames(styles.container, className)}>{children}</div>;
};
